export const GET_STORE_ITEM_PACKAGE_LIST = 'GET_STORE_ITEM_PACKAGE_LIST'
export const DELETE_STORE_ITEM_PACKAGE_BY_ID = 'DELETE_STORE_ITEM_PACKAGE_BY_ID'
export const GET_STORE_ITEM_PACKAGE_BY_ID = 'GET_STORE_ITEM_PACKAGE_BY_ID'
export const DELETE_STORE_PACKAGE_ITEMS_IN_BULK = 'DELETE_STORE_PACKAGE_ITEMS_IN_BULK'
export const ADD_STORE_ITEM_PACKAGE = 'ADD_STORE_ITEM_PACKAGE'
export const UPDATE_STORE_ITEM_PACKAGE = 'UPDATE_STORE_ITEM_PACKAGE'
